import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import distanceInWordsToNow from 'date-fns/distance_in_words_to_now';
import isFuture from 'date-fns/is_future';

import './pickTime.scss';

const PickTime = ({timestamp}) => (
  <div className={classnames('pick-time', {future: isFuture(timestamp)})}>
    {distanceInWordsToNow(timestamp, {addSuffix: true})}
  </div>
);

PickTime.propTypes = {
  timestamp: PropTypes.number.isRequired,
};

PickTime.defaultProps = {};

export default PickTime;
